var map = {
	"./404.svg": "2tja",
	"./close.svg": "a+g5",
	"./gou.svg": "K6NV",
	"./left.svg": "Pigz",
	"./right.svg": "5R/3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5iUR";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/global nonrecursive \.svg$
// module id = 5iUR
// module chunks = 55